module.exports = __webpack_public_path__ + "img/dizhi.1f07f025.png";